<template>
  <Component
    :is="maxSmall ? DrawerClose : SheetClose"
    class="flex items-center justify-center"
  >
    <slot>
      <XClose
        class="w-6 h-6 fg-quinary hover:fg-quinary_hover transition-colors"
      />
    </slot>
  </Component>
</template>

<script setup>
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { DrawerClose } from "@/Shadcn/Components/ui/drawer";
import { SheetClose } from "@/Shadcn/Components/ui/sheet";
import { XClose } from "@/Icons";

const { maxSmall } = useBreakpoints();
</script>
